export default function IosFootballOutline() {
	return (
		<div
			className="ion-icon-ios-football-outline"
			dangerouslySetInnerHTML={ {
				__html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<path d="M256,48C141.137,48,48,141.136,48,256c0,114.864,93.137,208,208,208c114.872,0,208-93.138,208-208
	C464,141.138,370.87,48,256,48z M297.151,442.179c-13.514,2.657-30.327,4.187-44,4.45c-13.198-0.195-26.074-1.735-38.5-4.493
	c-2.144-0.549-4.383-1.138-6.805-1.777l-24.417-65.435L203.074,336h105.854l0.57,1.076l19.34,38.852L305.22,440.21
	C302.553,440.924,299.862,441.579,297.151,442.179z M89.317,163.522l18.188,52.284l0.175,0.504L65.376,252.92
	C65.892,220.535,74.52,190.088,89.317,163.522z M189.578,77.28L247,116.576v58.147l-70.997,60.067L126.6,212.28l-4.167-1.899
	l-22.332-64.019C122.11,115.158,153.239,90.83,189.578,77.28z M325.025,247.206l0.921,0.765L307.569,320H204.431l-18.485-72.453
	l0.445-0.376l68.873-58.27L325.025,247.206z M446.626,252.921l-42.454-36.738l0.127-0.364l18.298-52.451
	C437.447,189.972,446.109,220.473,446.626,252.921z M411.564,146.067l-22.432,64.483l-53.992,24.388L264,174.723v-58.147
	l57.596-39.415C357.958,90.644,389.501,114.913,411.564,146.067z M66.144,273.414l53.756-46.518l49.539,22.599l0.559,0.255
	l19.718,77.287l-20.433,38.529l-69.86-0.915C81.075,338.291,69.209,307.105,66.144,273.414z M342.719,365.565l-20.434-38.529
	l19.752-77.416l49.997-22.781l53.822,46.575c-3.065,33.691-14.932,64.877-33.277,91.236L342.719,365.565z M255.257,102.67
	l-46.126-31.498c15-3.806,30.701-5.836,46.869-5.835c15.961,0,31.466,1.982,46.293,5.694L255.257,102.67z M166.423,381.529
	l0.848,2.511l19.946,49.781c-29.239-11.351-55.011-29.704-75.232-53.006L166.423,381.529z M324.563,433.904l17.934-48.608
	l1.627-3.748l55.892-0.732C379.744,404.175,353.893,422.562,324.563,433.904z"/>
</svg>
`,
			} }
		/>
	);
}
